import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=066273ce"
import script from "./company-list.ts?vue&type=script&lang=js&external"
export * from "./company-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports